<template>
    <div class="modal-card add_company_card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3">
                Añadir Compañia
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="section_filter centered_div">
            <table>
                <tr>
                    <td class="filtrar_text" colspan="2">Crear compañia:</td>
                </tr>
                <tr>
                    <td class="input_title">Rut:</td>
                    <td>
                        <div class="input_surround">
                            <Input rules="required|min:10|max:12|rut" type="text" placeholder="12345678-9"
                                input-id="rut" name="rut" ref="rut" v-model="company_rut" :specificClass="true"
                                inputClasses="input_company" />
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="input_title">Nombre Compañia:</td>
                    <td>
                        <div class="input_surround">
                            <Input rules="required" type="text" placeholder="(Razón Social)" input-id="company_name"
                                name="company_name" ref="company_name" v-model="company_name" :specificClass="true"
                                :rutMask="rutMask" inputClasses="input_company" />
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div>
                            <span class="message">
                                {{ message }}
                            </span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <button :disabled="companies_list.length > 0" @click="crearCompania()"
                            :class="['grabar_compania', { 'disabled_button': companies_list.length > 0 }]">
                            Crear Compañia
                        </button>
                    </td>
                </tr>
            </table>
        </section>
        <section class="section-companies">
            <div role="navigation" aria-label="main navigation" class="analyst_users">
                <table>
                    <tr v-for="companies_sub_list in companies_list" v-bind:key="companies_sub_list[0].id">
                        <td v-for="company in companies_sub_list" v-bind:key="company.id" class="company_td">
                            <div class="long_company_name">
                                {{ company.rut + ' ' + company.name }}
                            </div>
                            <div class="nombre_email nobreak">
                                {{ company.email }}
                            </div>
                            <div class="nombre_email nobreak">
                                {{ company.nombre + ' ' + company.apellido }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
    </div>
</template>

<script>
import { allCompanies, saveCompany } from "@/api/carteraAnalista";
import Input from "@/components/inputs/Input";

export default {
    name: "AddCompany",
    components: {
        Input,
    },
    data() {
        return {
            analysts_list: [],
            companies_list: [],
            raw_companies_list: [],
            analistas: [],
            addedAnalysts: [],
            deletedAnalysts: [],
            selectedUserId: -1,
            selectedCompany: -1,
            company_rut: "",
            company_name: "",
            message: "",
            loading: false,
            rutMask: ["#######-B", "########-B", "#########-B"],
        };
    },
    computed: {
        isInvalidForm: function () {
            if (this.selectedCompany != -1 && this.addedAnalysts.length > 0 || this.deletedAnalysts.length > 0) {
                return false
            }
            return true
        }
    },
    methods: {
        calcSize(largo) {
            return Math.ceil(Math.log(largo + 1));
        },
        partition(list) {
            var result = [];
            const largo = list.length;
            const size = this.calcSize(largo);
            for (var i = 0; i < largo; i = i + size) {
                result.push(list.slice(i, i + size));
            }
            return result;
        },
        async crearCompania() {
            this.loading = true;
            const value = await saveCompany(this.company_rut, this.company_name);
            this.message = value.data['msg'];
            this.loading = false;
        },
        filterCompanies(type, value) {
            if (this.company_rut == "" && this.company_name == "") {
                this.companies_list = this.partition(this.raw_companies_list);
            } else {
                const lesser_companies = this.raw_companies_list.filter(
                    (company) => company[type].toUpperCase().includes(value.toUpperCase())
                );
                this.companies_list = this.partition(lesser_companies);
            }
        },
    },
    mounted() {
        allCompanies(true).then((response) => {
            this.raw_companies_list = response.data;
            this.filterCompanies('rut', '');
        }).catch((error) => {
            console.log('error:', error);
        });
    },
    watch: {
        company_rut(newValue) {
            this.filterCompanies('rut', newValue);
        },
        company_name(newValue) {
            this.filterCompanies('name', newValue);
        }
    },
};
</script>
<style scoped>
.add_company_card {
    text-align: center;
    width: clamp(500px, 800px, 1000px);
    height: 1000px;
}

.analyst_users {
    padding-top: 10px;
    padding-left: 30px;
}

.nombre_email {
    font-size: 80%;
}

.company_td {
    font-size: 90%;
    border: 0px solid #000000;
    padding: 0 5px 0 5px;
}

.section-analysts {
    background-color: #FcFdFf;
}

.section_filter {
    height: 210px;
    overflow: visible;
    background-color: #FbFcFe;
    padding: 5px 0 5px 0;
}

.section-companies {
    background-color: #F8F9Fd;
    overflow: auto;
}

.centered_div {
    display: flex;
    justify-content: center;
    align-items: center;
}

.filtrar_text {
    padding-right: 5px;
}

.modal-card-body {
    padding-top: 10px !important;
}

.selected_company {
    background-color: #ffff00 !important;
    border-color: #000000 !important;
}

.company_button {
    cursor: pointer;
    justify-content: center;
    border: 1px solid #444444;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    padding: 2%;
    margin: 2px;
}

.company_button:hover {
    background-color: #fffff3;
    transform: translateY(-2px);
}

.company_button:active {
    transform: translateY(1px);
}

.nobreak {
    white-space: nowrap;
}


.input_company {
    /* height: 10px !important; */
    line-height: 10px !important;
    margin: 15px !important;

}

.input_title {
    position: relative;
    text-align: right;
    top: 11px;
    padding-right: 10px;
}

.input_surround {
    margin: 10px 5px 20px 5px;
}

.grabar_compania {
    color: #000;
    padding: 10px;
    font-weight: 600;
    font-size: 110%;
}

.disabled_button {
    color: #999;
    font-weight: 400;
}

.long_company_name {
    max-width: 200px;
}

.message {
    padding: 10px;
}
</style>
